import axios from "../axiosInstance";

const gameAPI = {
  store: (payload) => axios.post("admin/game/store", payload),
  getList: (params) => axios.get("admin/game/list", { params }),

  getDetails: (payload) => axios.post("admin/game/details", payload),
  detailsforRegistration: (payload) => axios.post("admin/game/detailsforRegistration", payload),

  update: (payload) => axios.post("admin/game/update", payload),
  delete: (payload) => axios.post("admin/game/delete", payload),
};

export default gameAPI;
